{
  "shop.title": "Shop",
  "shop.subtitle": "Order products from ColorGlo HQ.",
  "shop.search": "Search product or article number",
  "shop.category.all": "All",
  "shop.empty": "No products match your search.",
  "shop.error": "The shop could not be loaded.",
  "shop.retry": "Try again",
  "shop.sizes.one": "{count} size",
  "shop.sizes.other": "{count} sizes",
  "shop.no_image": "No image",
  "shop.back": "Back to the shop",
  "shop.product.not_found": "This product is no longer in the shop.",
  "shop.product.variants": "Sizes",
  "shop.product.sku": "Art. no.",
  "shop.product.size": "Size",
  "shop.product.status": "Status",
  "shop.product.size_missing": "Not given",
  "shop.product.orderable": "Can be ordered",
  "shop.product.unavailable": "Cannot be ordered",
  "shop.product.video": "Watch video",
  "shop.product.content": "Product information",
  "shop.cart.title": "Cart",
  "shop.cart.add": "Add to cart",
  "shop.cart.added": "{name} is in your cart.",
  "shop.cart.empty": "Your cart is empty.",
  "shop.cart.browse": "Go to the shop",
  "shop.cart.qty": "Quantity",
  "shop.cart.decrease": "Decrease quantity",
  "shop.cart.increase": "Increase quantity",
  "shop.cart.remove": "Remove",
  "shop.cart.unavailable": "Can no longer be ordered and will not be sent.",
  "shop.cart.notes": "Message to HQ",
  "shop.cart.notes_hint": "Optional, for example a preferred delivery day.",
  "shop.cart.submit": "Send order",
  "shop.cart.sending": "Sending …",
  "shop.cart.sent": "Your order has been sent to HQ.",
  "shop.cart.failed": "The order could not be sent. Please try again.",
  "shop.cart.review_note": "HQ reviews the order and may lower quantities if something is out of stock.",
  "shop.orders.title": "My orders",
  "shop.orders.empty": "No orders yet.",
  "shop.orders.number": "Order {number}",
  "shop.orders.date": "Date",
  "shop.orders.status": "Status",
  "shop.orders.items.one": "{count} item",
  "shop.orders.items.other": "{count} items",
  "shop.orders.back": "All orders",
  "shop.orders.error": "Orders could not be loaded.",
  "shop.order.not_found": "Order not found.",
  "shop.order.lines": "Items",
  "shop.order.product": "Product",
  "shop.order.ordered": "Ordered",
  "shop.order.approved_qty": "Approved",
  "shop.order.delivery": "Delivery address",
  "shop.order.notes": "Message from the workshop",
  "shop.order.history": "History",
  "shop.order.cancel": "Cancel order",
  "shop.order.cancel_confirm": "Cancel order {number}? This cannot be undone.",
  "shop.order.keep": "Keep it",
  "shop.order.cancelled_toast": "The order is cancelled.",
  "shop.order.placed_by": "Placed by {name}",
  "shop.order.adjusted": "Adjusted by HQ",
  "shop.status.submitted": "Waiting for HQ",
  "shop.status.approved": "Approved",
  "shop.status.rejected": "Rejected",
  "shop.status.shipped": "Shipped",
  "shop.status.cancelled": "Cancelled",
  "shop.event.submitted": "Order sent",
  "shop.event.approved": "HQ approved the order",
  "shop.event.rejected": "HQ rejected the order",
  "shop.event.shipped": "HQ shipped the order",
  "shop.event.cancelled": "Order cancelled",
  "shop.hq.title": "Orders",
  "shop.hq.subtitle": "Orders from the workshops.",
  "shop.hq.all": "All",
  "shop.hq.workshop": "Workshop",
  "shop.hq.empty": "No orders here.",
  "shop.hq.decision": "Decision",
  "shop.hq.approve": "Approve",
  "shop.hq.approve_hint": "Lower the quantity, or set 0 for anything out of stock.",
  "shop.hq.note": "Message to the workshop",
  "shop.hq.reject": "Reject",
  "shop.hq.reject_reason": "Reason",
  "shop.hq.reject_hint": "The workshop will see the reason.",
  "shop.hq.approved_toast": "The order is approved.",
  "shop.hq.rejected_toast": "The order is rejected.",
  "shop.hq.nothing_left": "At least one line must remain. Reject the order instead.",
  "shop.hq.failed": "The decision could not be saved. Please try again.",
  "shop.orders.order": "Order",
  "shop.invoice.title": "Delivery note",
  "shop.invoice.invoice_number": "Delivery note number",
  "shop.invoice.invoice_date": "Date",
  "shop.invoice.order_number": "Order number",
  "shop.invoice.order_date": "Order date",
  "shop.invoice.ship_date": "Shipped",
  "shop.invoice.seller": "From",
  "shop.invoice.buyer": "To",
  "shop.invoice.org_nr": "Company no.",
  "shop.invoice.vat_nr": "VAT no.",
  "shop.invoice.sku": "Art. no.",
  "shop.invoice.product": "Product",
  "shop.invoice.qty": "Qty",
  "shop.invoice.download": "Download delivery note {number}",
  "shop.email.order_placed.subject": "New order {number} from {workshop}",
  "shop.email.order_placed.heading": "New order from {workshop}",
  "shop.email.order_placed.body": "{workshop} has sent order {number}. It is waiting for your decision.",
  "shop.email.order_approved.subject": "Order {number} is approved",
  "shop.email.order_approved.heading": "Your order is approved",
  "shop.email.order_approved.body": "HQ has approved order {number}. We will let you know when it ships.",
  "shop.email.order_rejected.subject": "Order {number} was rejected",
  "shop.email.order_rejected.heading": "Your order could not be accepted",
  "shop.email.order_rejected.body": "HQ has unfortunately rejected order {number}.",
  "shop.email.order_shipped.subject": "Order {number} has shipped – delivery note {invoice}",
  "shop.email.order_shipped.heading": "Your order is on its way",
  "shop.email.order_shipped.body": "Order {number} has shipped. Delivery note {invoice} is attached.",
  "shop.email.adjusted": "HQ has adjusted the quantity on one or more lines.",
  "shop.email.note": "Message from HQ: {note}",
  "shop.email.reason": "Reason: {note}",
  "shop.email.cta": "View the order",
  "shop.hq.ship": "Mark as shipped",
  "shop.hq.ship_confirm": "A shipment is recorded for order {number}. A delivery note for what ships now is created and emailed to the workshop. This cannot be undone.",
  "shop.hq.shipped_toast": "The order is shipped and the delivery note is created.",
  "shop.order.invoice": "Delivery note {number}, {date}",
  "shop.hq.not_now": "Not now",
  "shop.admin.title": "Products",
  "shop.admin.subtitle": "The shop's range and what can be ordered.",
  "shop.admin.search": "Search product or article number",
  "shop.admin.new": "New product",
  "shop.admin.create": "Create",
  "shop.admin.name": "Name",
  "shop.admin.category": "Category",
  "shop.admin.summary": "Short description",
  "shop.admin.content": "Product information",
  "shop.admin.content_hint": "Blank line between paragraphs. **bold text** for labels like Application:.",
  "shop.admin.video": "Video link",
  "shop.admin.active": "Shown in the shop",
  "shop.admin.hidden": "Hidden",
  "shop.admin.visible": "Shown",
  "shop.admin.blocked.one": "{count} blocked",
  "shop.admin.blocked.other": "{count} blocked",
  "shop.admin.save": "Save",
  "shop.admin.saved": "Saved.",
  "shop.admin.failed": "Could not save. Check the fields and try again.",
  "shop.admin.back": "All products",
  "shop.admin.image": "Image",
  "shop.admin.upload": "Upload image",
  "shop.admin.upload_hint": "JPEG, PNG or WebP, at most 3 MB.",
  "shop.admin.variants": "Sizes",
  "shop.admin.sku": "Art. no.",
  "shop.admin.size": "Size",
  "shop.admin.orderable": "Orderable",
  "shop.admin.add_variant": "Add size",
  "shop.admin.settings": "Settings",
  "shop.admin.settings_title": "Shop settings",
  "shop.admin.seller": "Delivery note sender",
  "shop.admin.seller_hint": "Printed at the top of every delivery note. Company and VAT numbers show once filled in.",
  "shop.admin.legal_name": "Company name",
  "shop.admin.address": "Address",
  "shop.admin.postcode": "Postcode",
  "shop.admin.city": "City",
  "shop.admin.email": "Email",
  "shop.admin.phone": "Phone",
  "shop.admin.org_nr": "Company no.",
  "shop.admin.vat_nr": "VAT no.",
  "shop.admin.empty": "No products match your search.",
  "shop.hq_bell.open": "Show HQ notifications",
  "shop.hq_bell.title": "Orders from workshops",
  "shop.hq_bell.empty": "No new orders.",
  "shop.hq_bell.kind.shop_order_placed": "New order",
  "shop.hq_bell.kind.shop_order_cancelled": "Order cancelled",
  "shop.hq_bell.body": "{workshop} · order {number}",
  "shop.hq_bell.mark_all_read": "Mark all as read",
  "shop.hq_bell.see_all": "View all",
  "shop.hq_history.title": "Order notifications",
  "shop.hq_history.unread.one": "{count} unread",
  "shop.hq_history.unread.other": "{count} unread",
  "shop.hq_history.all_read": "All caught up.",
  "shop.hq_history.unread_only": "Unread only",
  "shop.hq_history.empty": "No notifications yet.",
  "shop.hq_history.empty_filtered": "Nothing matches the filter.",
  "shop.hq_history.load_more": "Show more",
  "shop.hq_history.error": "Notifications could not be loaded.",
  "shop.email.order_cancelled.subject": "Order {number} was cancelled by HQ",
  "shop.email.order_cancelled.heading": "Your order is cancelled",
  "shop.email.order_cancelled.body": "HQ has cancelled order {number}. Nothing has been sent.",
  "shop.email.order_closed.subject": "Order {number} is complete – the rest will not be sent",
  "shop.email.order_closed.heading": "Your order is complete",
  "shop.email.order_closed.body": "HQ has sent what was in stock of order {number}. The rest will not be sent, and the order now covers only what was shipped, as on the delivery notes.",
  "shop.email.short_line": "{product}: {qty} of {ordered} sent",
  "shop.email.tracking": "Tracking number: {tracking}",
  "shop.status.partially_shipped": "Partly shipped",
  "shop.status.delivered": "Delivered",
  "shop.event.partially_shipped": "HQ shipped part of the order",
  "shop.event.delivered": "The workshop received the order",
  "shop.hq_bell.kind.shop_order_delivered": "Order received",
  "shop.order.shipped_qty": "Shipped",
  "shop.order.shipments": "Shipments",
  "shop.order.shipment": "Shipment {number}",
  "shop.order.tracking": "Tracking: {tracking}",
  "shop.order.no_tracking": "No tracking number",
  "shop.order.received": "Confirm received",
  "shop.order.received_confirm": "Has the whole order arrived?",
  "shop.order.received_toast": "Thanks! The order is marked as received.",
  "shop.hq.ship_title": "Ship",
  "shop.hq.ship_hint": "Enter how many to ship now. The rest can follow later.",
  "shop.hq.tracking": "Tracking number",
  "shop.hq.ship_now": "Ship",
  "shop.hq.to_ship": "To ship",
  "shop.hq.cancel": "Cancel order",
  "shop.hq.cancel_hint": "Nothing has shipped. The workshop will see the reason.",
  "shop.hq.cancelled_toast": "The order is cancelled.",
  "shop.hq.close": "Close without the rest",
  "shop.hq.close_hint": "Anything not yet shipped is removed from the order, which then covers only what was shipped. The workshop gets an email with the reason.",
  "shop.hq.closed_toast": "The order is closed.",
  "shop.cart.delivery": "Delivery address",
  "shop.cart.delivery_workshop": "Workshop address",
  "shop.cart.delivery_other": "Another address",
  "shop.cart.delivery_incomplete": "The workshop's address is incomplete. Enter a delivery address.",
  "shop.cart.delivery_name": "Recipient",
  "shop.cart.delivery_line1": "Street address",
  "shop.cart.delivery_line2": "C/o or floor (optional)",
  "shop.cart.delivery_postcode": "Postcode",
  "shop.cart.delivery_city": "City",
  "shop.cart.no_longer_available": "No longer in the shop and will not be sent.",
  "shop.paused": "This workshop is paused and cannot order right now.",
  "shop.email_log.title": "Email",
  "shop.email_log.empty": "No emails yet.",
  "shop.email_log.kind.order_placed": "New order to HQ",
  "shop.email_log.kind.order_approved": "Approved",
  "shop.email_log.kind.order_rejected": "Rejected",
  "shop.email_log.kind.order_shipped": "Shipment {number} with delivery note",
  "shop.email_log.kind.order_cancelled": "Cancelled by HQ",
  "shop.email_log.kind.order_closed": "Closed without the rest",
  "shop.email_log.status.pending": "Pending",
  "shop.email_log.status.sent": "Sent",
  "shop.email_log.status.failed": "Failed",
  "shop.email_log.resend": "Send again",
  "shop.email_log.resent": "The email is being sent again.",
  "shop.export.title": "Export",
  "shop.export.hint": "Excel file (CSV) for the chosen period.",
  "shop.export.from": "From",
  "shop.export.to": "To",
  "shop.export.orders": "Order lines",
  "shop.export.invoices": "Delivery notes",
  "shop.admin.language": "Language",
  "shop.admin.translation_hint": "An empty field shows the Swedish text.",
  "shop.admin.categories": "Categories",
  "shop.admin.categories_hint": "Names in every language. An empty field shows the Swedish name.",
  "shop.admin.new_category": "New category",
  "shop.admin.move_up": "Move up",
  "shop.admin.move_down": "Move down",
  "shop.admin.delete": "Delete",
  "shop.admin.delete_product": "Delete product",
  "shop.admin.delete_confirm": "Delete {name}? Only possible if nobody has ordered it. Otherwise, hide it instead.",
  "shop.admin.deleted": "Deleted.",
  "shop.admin.in_use": "Cannot be deleted because it has been ordered. Hide it instead.",
  "shop.admin.category_in_use": "The category has products and cannot be deleted.",
  "shop.analytics.tab": "Shop",
  "shop.analytics.title": "The shop across the network",
  "shop.analytics.body": "Orders from the workshops in the chosen period.",
  "shop.analytics.orders": "Orders",
  "shop.analytics.fill_rate": "Fill rate",
  "shop.analytics.fill_rate_hint": "Share of the ordered quantity that HQ approved.",
  "shop.analytics.approve_time": "Time to decision",
  "shop.analytics.ship_time": "Time to ship",
  "shop.analytics.deliver_time": "Time to receipt",
  "shop.analytics.median": "Median",
  "shop.analytics.hours": "{value} h",
  "shop.analytics.days": "{value} d",
  "shop.analytics.none": "—",
  "shop.analytics.statuses": "Status",
  "shop.analytics.per_day": "Orders per day",
  "shop.analytics.chart_label": "{count} orders between {from} and {to}",
  "shop.analytics.workshops": "Workshops",
  "shop.analytics.workshop": "Workshop",
  "shop.analytics.country": "Country",
  "shop.analytics.last_order": "Last order",
  "shop.analytics.no_orders": "No orders",
  "shop.analytics.products": "Most ordered products",
  "shop.analytics.qty": "Qty",
  "shop.analytics.ordered_by": "Workshops",
  "shop.analytics.empty": "No orders in this period.",
  "shop.analytics.error": "The figures could not be loaded.",
  "shop.cart.summary": "Your order",
  "shop.analytics.units": "Approved units",
  "shop.analytics.delivery_notes": "Delivery notes"
}
